import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm.78 14.89h-1.56v-1.55h1.56zm0-3.13h-1.56V7.11h1.56z" }));
export default createSvgIcon(iconPath, "Alert");
//# sourceMappingURL=AlertIcon.js.map